:host {
  --aha-roadmap-bar--bar-color: var(--aha-green-500);
  --aha-roadmap-bar--border-color: ;
  --aha-roadmap-bar--border-width: 1px;
  --aha-roadmap-bar--shadow: var(--theme-shadow-shallow);
  --aha-roadmap-bar--height: 1em;

  display: block;
  height: var(--aha-roadmap-bar--height);
  color: var(--aha-roadmap-bar--border-color);
}
:host,
:host * {
  box-sizing: border-box;
}

:host([thick]) {
  height: calc(var(--aha-roadmap-bar--height) * 2);
}
#color {
  background-color: var(--aha-roadmap-bar--bar-color);
}

#wrapper {
  display: flex;
  flex-direction: column;
}

#bar,
#gutter,
#progress {
  --gradient: linear-gradient(
    to right,
    var(--aha-roadmap-bar--gradient-start-color) 0,
    var(--aha-roadmap-bar--gradient-start-color) var(--aha-roadmap-bar--start-fade-offset),
    var(--aha-roadmap-bar--gradient-color)
      calc(var(--aha-roadmap-bar--start-fade-offset) + var(--aha-roadmap-bar--start-fade-distance)),
    var(--aha-roadmap-bar--gradient-color)
      calc(
        100% - var(--aha-roadmap-bar--end-fade-offset) - var(--aha-roadmap-bar--end-fade-distance)
      ),
    var(--aha-roadmap-bar--gradient-end-color) calc(100% - var(--aha-roadmap-bar--end-fade-offset)),
    var(--aha-roadmap-bar--gradient-end-color) 100%
  );
  background: var(--gradient);
}

#bar {
  --aha-roadmap-bar--start-fade-offset: 0%;
  --aha-roadmap-bar--end-fade-offset: 0%;
  --aha-roadmap-bar--default-fade-distance: min(30%, 30px);
  --aha-roadmap-bar--start-fade-distance: var(--aha-roadmap-bar--default-fade-distance);
  --aha-roadmap-bar--end-fade-distance: var(--aha-roadmap-bar--default-fade-distance);
  --aha-roadmap-bar--start-fade-color: transparent;
  --aha-roadmap-bar--end-fade-color: transparent;
  --aha-roadmap-bar--progress: 100%;
  --aha-roadmap-bar--gradient-start-color: transparent;
  --aha-roadmap-bar--gradient-end-color: transparent;
  --aha-roadmap-bar--gradient-color: var(--aha-roadmap-bar--border-color);
  --aha-roadmap-bar--start-fade-offset: var(--aha-roadmap-bar--default-fade-distance);
  --aha-roadmap-bar--end-fade-offset: var(--aha-roadmap-bar--default-fade-distance);
  --aha-roadmap-bar--left-border-radius: var(--Common--border-radius);
  --aha-roadmap-bar--right-border-radius: var(--Common--border-radius);

  /* Ensure that the fade distance for bars with no specified end date is respected, but also ensure that the progress bar has a well defined "end" line as much as possible. */
  --aha-roadmap-bar--progress-curvature: min(
    calc(var(--aha-roadmap-bar--progress) - 100% + var(--aha-roadmap-bar--default-fade-distance)),
    var(--aha-roadmap-bar--default-fade-distance)
  );

  flex-grow: 1;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  height: 100%;
  background: var(--gradient);
  position: relative;
  box-shadow: var(--aha-roadmap-bar--shadow);
  border: 1px solid var(--aha-roadmap-bar--border-color);
  border-radius: var(--Common--border-radius);
}
:host(:not([start])) #bar {
  border-left-width: 0;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
:host(:not([end])) #bar {
  border-right-width: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

#gutter,
#progress {
  --aha-roadmap-bar--start-fade-offset: 0%;
  --aha-roadmap-bar--end-fade-offset: 0%;
  position: absolute;
  border-radius: inherit;
}
#gutter {
  --aha-roadmap-bar--gradient-color: var(--aha-roadmap-bar--gutter-color);
  inset: 0;
}
#progress {
  --aha-roadmap-bar--gradient-color: var(--aha-roadmap-bar--bar-color);
  --aha-roadmap-bar--end-fade-distance: var(--aha-roadmap-bar--progress-curvature);

  inset: 0;
  width: var(--aha-roadmap-bar--progress);
  transition: width 0.2s;
}
:host([start]) #bar {
  --aha-roadmap-bar--gradient-start-color: var(--aha-roadmap-bar--gradient-color);
  border-top-left-radius: var(--aha-roadmap-bar--left-border-radius);
  border-bottom-left-radius: var(--aha-roadmap-bar--left-border-radius);
}
:host([start]) #gutter {
  --aha-roadmap-bar--gradient-start-color: var(--aha-roadmap-bar--gradient-color);
  border-top-left-radius: inherit;
  border-bottom-left-radius: inherit;
}
:host([start]) #progress {
  --aha-roadmap-bar--gradient-start-color: var(--aha-roadmap-bar--gradient-color);
}
:host([end]) #bar {
  --aha-roadmap-bar--gradient-end-color: var(--aha-roadmap-bar--gradient-color);
  border-top-right-radius: var(--aha-roadmap-bar--right-border-radius);
  border-bottom-right-radius: var(--aha-roadmap-bar--right-border-radius);
}
:host([end]) #gutter {
  --aha-roadmap-bar--gradient-end-color: var(--aha-roadmap-bar--gradient-color);
  border-top-right-radius: inherit;
  border-bottom-right-radius: inherit;
}
:host([end]) #progress {
  --aha-roadmap-bar--gradient-end-color: var(--aha-roadmap-bar--gradient-color);

  /* Ensure that a bar with a definite end date has a progress bar that has a right radius of zero _until_ it needs to have a border in order to fit into the available corner radius of the #gutter element. */
  --aha-roadmap-bar--right-progress-radius: min(
    calc(var(--aha-roadmap-bar--progress) - 100% + var(--aha-roadmap-bar--right-border-radius)),
    var(--aha-roadmap-bar--right-border-radius)
  );
  border-top-right-radius: var(--aha-roadmap-bar--right-progress-radius);
  border-bottom-right-radius: var(--aha-roadmap-bar--right-progress-radius);
}

#label {
  position: absolute;
  inset: 0;
  z-index: 1;
  white-space: nowrap;
  flex-grow: 1;
  display: flex;
  align-items: center;
  visibility: hidden;
}
:host([label-visible]) #label {
  visibility: visible;
}

/* Milestone specific styles */
:host([milestone]) #bar {
  --aha-roadmap-bar--left-border-radius: 50%;
  --aha-roadmap-bar--right-border-radius: 50%;
  --aha-roadmap-bar--start-fade-distance: 0%;
  --aha-roadmap-bar--end-fade-distance: 0%;

  aspect-ratio: 1;
  border-radius: var(--aha-roadmap-bar--left-border-radius)
    var(--aha-roadmap-bar--right-border-radius) var(--aha-roadmap-bar--right-border-radius)
    var(--aha-roadmap-bar--left-border-radius);
  border: 1px solid var(--aha-roadmap-bar--border-color);
}
:host([milestone]) #gutter {
  inset: 0;
  overflow: hidden;
}
:host([milestone]) #progress {
  --aha-roadmap-bar--end-fade-distance: 0%;
  border-radius: 0;
}
